import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  getMlmfuserMaster,
  updateMlmfCustomerWalletReq,
  saveMlmfCustomerWalletREQ,
  getcustomerwalletlist,
} from "../../../../apiservicescall/api";

import Select from "react-select";
import Table from "@mui/material/Table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import {
  // Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
  
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { Form, FormGroup, Label, Input } from "reactstrap";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";
import  RctSectionLoader from "../RctSectionLoader/RctSectionLoader";

const WalletMaster = () => {
  const [userlist, setuserlist] = useState([]);
  const [selectedusers, setSelectedusers] = useState([
    { label: "", value: "" },
  ]);

  const [selectedusersId, setSelectedusersId] = useState([
    { label: "", value: "" },
  ]);
  const [walletModal, SetWalletmodal] = useState(false);

  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);

  const [startdate, setDate] = useState(new Date());
  const [isget, setIsget] = useState(false);

  const [walletamount, SetWalletAmount] = useState({});
  const [description, steDescription] = useState({});
  const [errors, setErrors] = useState({
    amount: null,
    //customerId: null,
    reason: null,
    startDate: null,
    // walletId: null,
  });
  const [customerid, setCustomerId] = useState({});
  const [WalletId, setWalletId] = useState({});
  const [formIsValid, setFormIsValid] = useState(false);

  const [walletDetails, setWalletDetails] = useState(
    {
      amount: 0,
      customerId: { label: "", value: "" },
      customerName:"",
      reason: "",
      startDate: new Date(),
      walletId: 0,
    },
  );
  const [cusWalletlist, setCusWalletlist] = useState([]);
  const today = new Date();

  const[listmast ,setListmast] =useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getuserMaster();
  }, []);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [approvalpopup, setApprovalPopup] = useState(false);
  const getuserMaster = async () => {
    let getsuserList = await getMlmfuserMaster();

    let getsuserValue = (getsuserList && getsuserList.data.data) || [];
console.log("getsuserValue",getsuserValue);
    let dropdownusermaster =
      getsuserValue &&
      getsuserValue.map(({ id, name }) => ({
        label: name,
        value: id,
      }));
    setuserlist(dropdownusermaster);
    // console.log("dropdownusermaster",dropdownusermaster);
  };

  const getWalletHistory = async () => {
    let customerId = selectedusers.value;
    let getwalletlist = await getcustomerwalletlist(customerId);
   // console.log(getwalletlist);
    let getwallet = (getwalletlist && getwalletlist.data.data) || [];
  
    setCusWalletlist(getwallet);


    // console.log("getwallet", getwallet);
  };

  const saveupdatewalletapi = async () => {

    setLoader(true);
    let Startdate = walletDetails.startDate || [];
    let date =
      Startdate.getFullYear() +
        "-" +
        (Startdate.getMonth() + 1) +
        "-" +
        Startdate.getDate() || [];

    let data = "";
    data =  {
        amount: Number(walletDetails.amount) || [],
        customerId: selectedusers.value || [],
        //customerId: walletDetails.customerId.value ,
        reason: "Subscription wallet amount" + " " + walletDetails.reason || [],
        startDate: date || [],
      };
    

    //console.log("parseInt (walletDetails.amount)",parseInt (walletDetails.amount));
    let reqforupload;
    if (!isedit) {
      reqforupload = await saveMlmfCustomerWalletREQ(data);
    } else {
      reqforupload = await updateMlmfCustomerWalletReq(data);
    }

    if (reqforupload?.status === 200) {
      setIsview(false);
      setIsedit(false);
      SetWalletmodal(false);
      setWalletDetails([{}]);
      getWalletHistory(selectedusers.value);
      setLoader(false);
      if (!isedit) {
        swal("Success!", "Wallet Added", "success");
      } else {
        swal("Success!", "Wallet Updated", "success");
      }
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      SetWalletmodal(!walletModal);
      setLoader(false);
    }
  };

  const opnAddNewUserModal = (e) => {
    e.preventDefault();
    SetWalletmodal(!walletModal);
    setIsview(false);
    setIsedit(false);
    setFormIsValid();
  };

  //   const onEditwallet = (items) => {

  //     SetWalletmodal(!walletModal)
  //     console.log("itemfun", items);
  //     let Startdate = new Date();
  //     console.log("Startdate", Startdate);
  //     let date = Startdate.getFullYear() + "-" + (Startdate.getMonth() + 1) + "-" + Startdate.getDate();

  //     let amount = Math.round(items.amount);
  // console.log("amount",amount);

  // SetWalletAmount(

  //       amount);

  //     setWalletDetails(
  //       [
  //         {
  //           amount: amount,
  //           customerId: items.customerId,
  //           reason: items.reason,
  //           startDate: date || [],
  //           walletId: items.walletId
  //         }
  //       ])

  //     setIsedit(true);
  //     setIsview(false);
  //     setErrors({});
  //     setFormIsValid(true);
  //   }

  const onChangeCommonpopupsetOutletvalue = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    const stringwithnumberPattern = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/;
    const stringPattern = /^[-a-zA-Z-()]+(\s+[-a-zA-Z()]+)*$/;
    const amountparten = /[0-9]+(\.[0-9]+)?$/;
    // if (key == "customerId") {

    //   if (!value) {
    //     addFieldValue = { [value.value]: null };
    //     errorsLocal["customerId"] = "select customer";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   } else {

    //     setSelectedusersId(
    //       {
    //         label: value.label,
    //         value: value.value,
    //       }
    //     )
    //     addFieldValue = { [key]: value.value };
    //     errorsLocal["customerId"] = "";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   }
    // }

    // if (key == "walletId") {
    //   if (!value) {
    //     addFieldValue = { [value]: null };
    //     errorsLocal["walletId"] = "Invalid";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   } else if (!stringwithnumberPattern.test(value)) {
    //     addFieldValue = { [key]: null };
    //     errorsLocal["walletId"] = "Invalid";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   } else {
    //     addFieldValue = { [key]: value };
    //     errorsLocal["walletId"] = "";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   }
    // }

    if (key == "amount") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["amount"] = "Enter the Amount";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringwithnumberPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["amount"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["amount"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "startDate") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["startDate"] = " Select Date";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["startDate"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "reason") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["reason"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringwithnumberPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["reason"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        errorsLocal["reason"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    console.log("addFieldValue", addFieldValue);
    console.log("errorsLocal", errorsLocal);
    console.log("formIsValidLocal", formIsValidLocal);
    const newFormData = { ...walletDetails };
    newFormData[key] = value;
    setWalletDetails(newFormData);
  };


  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };
  const options = {
    filter: true, 
      search: true, 
      selectableRows: false,
      responsive: "stacked",
      fixedHeader: true,
      tableBodyHeight: "60vh",
      fixedSelectColumn: true,
      page: currentPage,
      pagination: true,
      serverSide: false,
      rowsPerPage: itemsPerPage,
      rowsPerPageOptions: [10, 15, 100],
      onChangePage: (newPage) => {
        handleChangePage(newPage);
      },
      onChangeRowsPerPage: (numOfRows) => {
        onChangeRowsPerPage(numOfRows);
      },
      download: false,
      print: false,
      onFilterChange: (column, filterList, type, filterOptions, changedColumnIndex) => {
        
      },
      confirmFilters: true,
      customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
        return (
          <div style={{ marginTop: "40px" }}>
            <Button
              variant="contained"
              onClick={() => applyNewFilters()} 
            >
              Apply Filters
            </Button>
          </div>
        );
      },
      onFilterConfirm: (filterList) => {
        // Handle filter confirmation here if needed
      },
      onFilterDialogOpen: () => {
        // Handle filter dialog open event if needed
      },
      onFilterDialogClose: () => {
        // Handle filter dialog close event if needed
      },
    customToolbar: () => {
      return (
        <>
          {
           
          }
        </>
      );
    },
  };
  const columns = [
    {
      name: "customerId",
      label: "Customer ID ",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
   
    {
      name: "customerFirstName",
      label: "Customer Name",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    

    
   
    {
      name: "description",
      label: "Description",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",

     
      },
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",

     
      },
    },
      {
      name: "walletAmount",
      label: "Wallet Amount",
      options: {
        filter: true,
        sort: true,
        searchable: true, 
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",

     
      },
    },
    
  ];
  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  return (
    <>
      <div className="row loaderPostn">
      {loader && <RctSectionLoader />}
        <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12">
          <Card>
            <div class="row">
              <div class="col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <h3 className="me-auto main-hd">Wallet</h3>
                </div>
              </div>
              <div class="col-7 col-md-7 col-lg-7 row">
                <Card.Header className="card-title main-card">
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xlg-4 form-group  main-frm-grp"
                    style={{ width: "30.333333%",zIndex:"800" }}
                  >
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Customer
                    </label>
                    <Select
                      options={userlist}
                      value={selectedusers}
                      closeMenuOnSelect={true}
                      placeholder="choose"
                      autoComplete="off"
                      onChange={(event) => {
                        setSelectedusers(event);
                      }}
                    />
                  </div>

                  <div
                    class="col-4 col-md-4 col-lg-4 col-xlg-4 mt-4  form-group"
                    style={{ width: "41.33333%", display: "contents", }}
                  >
                    {selectedusers.value && (
                      <Button
                        className="me-2 btn-primary"
                        variant="success dark btn-sm "
                        // disabled={restarantvalue.value == ""}
                        style={{
                          backgroundColor: "green",
                          borderRadius: "2px",
                          border: "0px solid",
                          marginTop: "4%",
                        }}
                        onClick={() => {
                          getWalletHistory();
                          setIsget(!isget);
                          setListmast(true);
                        }}
                      >
                        <i
                          // class="fas fa-plus"
                          onClick={() => {
                            getWalletHistory();
                            setIsget(!isget);

                          }}
                        >
                          Get{" "}
                        </i>{" "}
                      </Button>
                    )}

                    {isget && (
                      <div
                        class="col-4 col-md-4 col-lg-4  mt-4 form-group"
                        style={{ width: "62.33333%" }}
                      >
                        <Button
                          className="mt-2"
                          variant="success dark btn-sm "
                          // disabled={restarantvalue.value == ""}
                          style={{
                            backgroundColor: "#1F3DB6",
                            borderRadius: "2px",
                            border: "0px solid",
                          }}
                          onClick={(e) => {
                            opnAddNewUserModal(e);
                          }}
                        >
                          <i
                            // class="fas fa-plus"
                            onClick={() => {}}
                          >
                            Add Wallet{" "}
                          </i>{" "}
                        </Button>
                      </div>
                    )}
                  </div>
                </Card.Header>
              </div>
            </div>
            <Card.Body
              className="scroll-tbl-fix-header"
              style={{ padding: "0.875rem" }}
            >
                <RctCollapsibleCard fullBlock>
              <RctCollapsibleCard fullBlock>
                <MuiThemeProvider theme={themeTable}>
                  <MUIDataTable
                    title={""}
                    data={userlist}
                    columns={columns}
                    options={options}
                    columOrder={columns}
                    className={"MuiTabCusCls"}
                  />
                </MuiThemeProvider>
              </RctCollapsibleCard>
            </RctCollapsibleCard>
              {/* <Table responsive stripped>
                <thead>
                  <tr>
                    <th>Customer ID</th>
                    <th>Customer Name</th>
                    <th>Description</th>

                    <th style={{ textAlign: "right" }}>Amount</th> */}

                    {/* <th style={{ textAlign: "right" }}>Wallet Amount</th> */}

                    {/* <th>
                      Action
                    </th> */}
                  {/* </tr>
                </thead>
                <tbody>
                  {cusWalletlist &&
                    cusWalletlist.map((items) => {
                      return (
                        <tr>
                          <td>{items.customerId}</td>

                          <td>{items.customerName}</td>
                          <td>{items.reason}</td>

                          <td style={{ textAlign: "right" }}>
                            ₹{items.amount}
                          </td>

                          <td style={{ textAlign: "right" }}>
                            ₹{items.customerTotalWallet}
                          </td> */}

                          {/* <td>
                          <Link
                            className="btn btn-primary shadow btn-xs sharp me-2"
                            onClick={() => {
                           
                              //onEditwallet(items)
                              console.log("items", items);
                            }}
                            style={{ background: "#008000" }}
                          >
                            <i className="fas fa-pencil-alt fa-lg"></i>
                          </Link>
                        </td> */}
                        {/* </tr>
                      );
                    })}
                  { listmast == true  && cusWalletlist?.length <= 0 ? (
                    <div style={{ color: "red", textAlign: "center", fontSize:"200%" }}>
                      {" "}
                      No Data Found{" "}
                    </div>
                  ) : (
                    setCusWalletlist
                  )}
                </tbody>
              </Table> */}
            </Card.Body>
          </Card>

          {
            <Modal
              isOpen={walletModal}
              // toggle={() => onClose()}
              style={{
                maxWidth: walletModal && "600px",
              }}
              backdrop="static"
            >
              <ModalHeader>
                {walletModal && isedit === false
                  ? `Add Wallet -- ${selectedusers.label}-${selectedusers.value}`
                  : `Update Wallet  -- ${selectedusers.label}-${selectedusers.value}`}
              </ModalHeader>

              <ModalBody>
                <div className="row">
                  {/* {( (isedit === false)?
                <div className="col-sm-3 col-md-3 col-xl-3">
                  <FormGroup>
                    <Label for="customerId">
                      Customer Name<span class="text-danger">*</span>
                    </Label>
                    <Select
                      options={userlist}
                      search
                      name="customerId"
                      placeholder="customerId "
                      autoComplete="off"
                      disabled ={isedit||isView}
                      // value={walletDetails?.customerId}
                      onChange={(e) => {
                        onChangeCommonpopupsetOutletvalue("customerId", e)
                      }}
                    />
                    <span style={{ color: "red" }}>{errors["customerId"]}</span>
                  </FormGroup>
                </div> :null)} */}

                  {/* <div className="col-sm-4 col-md-4 col-xl-4">
                  <FormGroup>
                    <Label for="customerId">
                      Customer ID<span class="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="customerId"
                      id="customerId"
                      placeholder="customerId "
                      maxLength="40"
                      required
                      autoComplete="off"
                      onChange={(e) => {
                       
                        setCustomerId(e)
                        onChangeCommonpopupsetOutletvalue("customerId", e.target.value)
                        console.log("e.target.value", e.target.value);
                      }}

                      value={walletDetails?.customerId}
                    />
                    <span style={{ color: "red" }}>{errors["customerId"]}</span>
                  </FormGroup>
                </div> */}

                  <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                    <FormGroup>
                      <Label for="startDate">
                        Date<span class="text-danger">*</span>
                      </Label>
                      <DatePicker
                        dateFormat="yyyy-MM-dd"
                        selected={startdate}
                        minDate={today}
                        onChange={(e) => {
                          setDate(e);
                          onChangeCommonpopupsetOutletvalue("startDate", e);
                        }}
                        value={walletDetails?.startDate}
                      />

                      <span style={{ color: "red" }}>
                        {errors["startDate"]}
                      </span>
                    </FormGroup>
                  </div>

                  <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                    <FormGroup>
                      <Label for="amount ">
                        Wallet Amount<span class="text-danger ">*</span>
                      </Label>
                      <Input
                        type="number"
                        name="amount"
                        id="amount"
                        required
                        autoComplete="off"
                        onChange={(e) => {
                          onChangeCommonpopupsetOutletvalue(
                            "amount",
                            e.target.value
                          );
                          SetWalletAmount(e.target.value);
                        }}
                        // value={walletDetails.amount}
                      />
                      <span style={{ color: "red" }}>{errors["amount"]}</span>
                    </FormGroup>
                  </div>

                  <div
                    className="col-sm-3 col-md-3 col-xl-3"
                    style={{ marginTop: "10px" }}
                  >
                    <FormGroup>
                      <Label for="reason">
                        Description<span class="text-danger">*</span>
                      </Label>
                      <Input
                        type="textarea"
                        name="description"
                        id="reason"
                        value={walletDetails.reason}
                        placeholder="description"
                        maxLength="200"
                        required
                        autoComplete="off"
                        onChange={(e) => {
                          steDescription(e);
                          onChangeCommonpopupsetOutletvalue(
                            "reason",
                            e.target.value
                          );
                        }}
                      />
                      <span style={{ color: "red" }}>{errors["reason"]}</span>
                    </FormGroup>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                {walletModal && (
                  <>
                    {isView === false && isedit === false  &&  (
                      <Button
                        variant="primary"
                        className={
                          !formIsValid ? "btn-disabled" : "btn-primary"
                        }
                        disabled={!formIsValid || loader === true}
                        onClick={() => {
                          saveupdatewalletapi();
                        }}
                      >
                        Submit
                      </Button>
                    )}
                    {isView === false && isedit === true && (
                      <Button
                        variant="contained"
                        className={
                          !formIsValid ? "btn-disabled" : "btn-primary"
                        }
                        disabled={!formIsValid}
                        onClick={() => {
                          saveupdatewalletapi();
                          setWalletDetails([]);
                        }}
                      >
                        Update
                      </Button>
                    )}

                    <Button
                      variant="secondary"
                      onClick={() => {
                        setFormIsValid();
                        SetWalletmodal(false);
                        setErrors({
                          amount: null,
                          reason: null,
                          startDate: null,
                        });

                        setIsview(false);
                        setIsedit(false);
                        setWalletDetails([
                          {
                            amount: "",
                            reason: "",
                            startDate: new Date(),
                            walletId: "",
                          },
                        ]);
                      }}
                    >
                      Cancel
                    </Button>
                  </>
                )}
              </ModalFooter>
            </Modal>
          }
        </div>
      </div>
    </>
  );
};

export default WalletMaster;
